import { supportRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [
  IRoleEnum.SUPER_ADMIN,
  IRoleEnum.ASSISTANT,
  IRoleEnum.Teacher,
  IRoleEnum.Student,
];

const supportRouteMetadata: IRouteMetadataObj<typeof supportRoutesObj> = {
  home: {
    title: "support.title",
    description: "support.description",
    lazy: () => import("@/pages/support/page"),
    mode: "index",
    type: "inner",
    icon: "HeadphoneLine",
    breadcrumbs: [],
    permission,
  },
};

export const supportRoutes = createRoute<typeof supportRoutesObj>(
  supportRoutesObj,
  supportRouteMetadata,
);
